export default __webpack_public_path__ + "static/rm-logo-e05425af301b123169dfb0cf5271acc0.svg";